export default "__VITE_ASSET__9LvKm3o2__"